import React from 'react';
import { Label } from '../ui/label';
import Select, { components } from 'react-select';
import { Checkbox } from '../ui/checkbox';

const CountryCommon = ({
  label = "Country",
  placeholder = "Select Country",
  countries = [],
  countriesAccept = [],
  formData,
  setFormData,
  selectedValues = [],
}) => {
  // Filter and sort country options
  const countryOptions = countries
    ?.filter((item) => countriesAccept.includes(item.countryName))
    ?.sort((a, b) => a.countryName.localeCompare(b.countryName))
    ?.map((item) => ({ label: item.countryName, value: item._id }));

  // Option component to render checkbox in the dropdown
  const OptionCountryOptions = ({ children, ...props }) => {
    const { onCheckedOptions } = props.selectProps;
    return (
      <components.Control {...props}>
        <div
          className="flex p-2 align-middle justify-start items-center text-sm w-full"
          onClick={() => onCheckedOptions(props)}
        >
          <span className="me-2">
            <Checkbox
              checked={selectedValues.includes(props.data.value)}
              aria-label="Select row"
              className="translate-y-[2px] border-black rounded-[4px]"
            />
          </span>
          {children}
        </div>
      </components.Control>
    );
  };

  // Update selected countries based on checkbox selection
  const onCheckedCountryOptions = (props) => {
    const { data } = props;
    if (data.value === "all") {
      // Toggle selection for all countries
      setFormData((prev) => ({
        ...prev,
        countriesId:
          selectedValues.length === countryOptions.length ? [] : countryOptions.map((opt) => opt.value),
      }));
    } else {
      setFormData((prev) => {
        const alreadyExists = prev.countriesId.includes(data.value);
        const newData = alreadyExists
          ? prev.countriesId.filter((item) => item !== data.value)
          : [...prev.countriesId, data.value];

        return { ...prev, countriesId: newData.filter((id) => id !== "all") };
      });
    }
  };

  // Helper to display selected country names in the placeholder
  const showNamesOfCountries = () => {
    return countryOptions
      .filter((country) => selectedValues.includes(country.value))
      .map((country) => country.label)
      .join(", ");
  };

  return (
    <div className="form-group grid grid-cols-12 items-center gap-1">
      <div className="label-wrapper col-span-12">
        <Label htmlFor="name" className="text-[13px] text-textV2 font-500 cursor-pointer">
          {label}:<span style={{ color: "red" }}>*</span>
        </Label>
      </div>
      <div className="field-wrapper col-span-12">
        <Select
          components={{ Option: OptionCountryOptions }}
          isSearchable={false}
          inputValue=""
          value={null}
          closeMenuOnSelect={false}
          onCheckedOptions={onCheckedCountryOptions}
          placeholder={selectedValues.length > 0 ? showNamesOfCountries() : placeholder}
          name={label}
          className="multi_react_select curves_selectors"
          options={countryOptions}
          styles={{
            menuList: (base) => ({
              ...base,
              fontSize: "10px",
              overflow: "auto",
              maxHeight: "500px",
              lineHeight: "1rem",
              fontWeight: 500,
              borderRadius: "0",
              backgroundColor: "transparent",
            }),
            menu: (base) => ({
              ...base,
              overflow: "auto",
              margin: 0,
              padding: 0,
              width: "100%",
              borderRadius: "0",
            }),
            input: (base) => ({ ...base, width: "100%" }),
            container: (base) => ({ ...base, width: "100%" }),
          }}
        />
      </div>
    </div>
  );
};

export default CountryCommon;
